import { api, config, helpers, ts } from '_core';

type TimeSeriesApiResponse = {
  data: ts.types.timeSeries.TimeSeries;
};

export const createTimeSeries = async (
  newData: ts.types.timeSeries.TimeSeriesDraft,
  callback: (_data: ts.types.timeSeries.TimeSeries) => void,
  errorCallback: (_error: string) => void
) => {
  try {
    const resp: TimeSeriesApiResponse = await api.time_series.create(newData);
    callback(resp.data);
  } catch (error) {
    errorCallback(`Error creating time series - ${helpers.parseApiError(error as ts.types.common.ApiError)}`);
  }
};

export const updateTimeSeries = async (
  id: number,
  newData: ts.types.timeSeries.TimeSeriesDraft,
  callback: (_data: ts.types.timeSeries.TimeSeries) => void,
  errorCallback: (_error: string) => void
) => {
  try {
    const resp: TimeSeriesApiResponse = await api.time_series.update(id, { ...newData });
    callback(resp.data);
  } catch (error) {
    errorCallback(`Error updating time series - ${helpers.parseApiError(error as ts.types.common.ApiError)}`);
  }
};

export const updateDefinition = async (
  id: number,
  definition: ts.types.timeSeries.DefinitionDraft,
  callback: (_data: ts.types.timeSeries.TimeSeries) => void,
  errorCallback: (_error: string) => void
) => {
  try {
    const updateData = { definition, is_valid: true } as ts.types.timeSeries.TimeSeriesDraft;
    const resp = await api.time_series.update(id, updateData, true);
    callback(resp.data);
  } catch (error) {
    errorCallback(`Error updating the definition - ${helpers.parseApiError(error as ts.types.common.ApiError)}`);
  }
};

export const keepCurrent = async (
  timeSeries: ts.types.timeSeries.TimeSeriesDraft,
  callback: (_data: ts.types.timeSeries.TimeSeries) => void,
  errorCallback: (_error: string) => void
) => {
  try {
    if (timeSeries.shared) return;
    const resp = await api.dates.keep_current({
      resource_id: timeSeries.id,
      resource_type: 'time_series',
      max_date: config.features.end_date,
    });
    callback(resp.resource);
  } catch (error) {
    errorCallback(`Error updating time series dates - ${helpers.parseApiError(error as ts.types.common.ApiError)}`);
  }
};

export const updateUiMetadata = async (
  timeSeries: ts.types.timeSeries.TimeSeries,
  uiMetaData: ts.types.timeSeries.UiMetaData,
  callback: (_data: ts.types.timeSeries.TimeSeries) => void,
  errorCallback: (_error: string) => void
) => {
  try {
    if (timeSeries.shared) return;
    const updateData = {
      ui_metadata: uiMetaData,
      skip_signature_check: true,
    } as ts.types.timeSeries.TimeSeriesDraft;
    const resp = await api.time_series.update(timeSeries.id, updateData);
    callback(resp.data);
  } catch (error) {
    errorCallback(`Error updating the resource metadata - ${helpers.parseApiError(error as ts.types.common.ApiError)}`);
  }
};
